<div class="container">
  <app-template [title]="'Cash Point'">
    <div class="all">
      <div class="both">
        <form
          [formGroup]="stateForm"
          (ngSubmit)="onSubmit($event)"
          class="form"
        >
          <span class="input">
            <mat-form-field>
              <mat-label>Amount Paid</mat-label>
              <input
                type="number"
                [(ngModel)]="total_Paid"
                (input)="onChangeTotla()"
                matInput
                placeholder=""
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Payment Type</mat-label>
              <mat-select formControlName="payment_type" matNativeControl>
                <mat-option value="Cash">Cash</mat-option>
                <mat-option value="Credit">Credit</mat-option>
                <mat-option value="Transfer">Transfer</mat-option>
                <mat-option value="Cheque ">Cheque </mat-option>
                <mat-option value="Dollar">Dollar</mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <button
            style="margin-left: 0"
            type="button"
            (click)="makeVisible()"
            class="bill"
            mat-raised-button
            color="primary"
          >
            Search
          </button>
          <!-- <div *ngIf="stateForm.touched && stateForm.invalid " class="form-error form-username-error">
            This username is not available
          </div> -->

          <div class="detail">
            <div style="width: 50%">
              <p>
                Name : <b style="width: 100%">{{ name }}</b>
              </p>
              <p>
                Net Amount : <b>{{ net | currency : "&#8358;" || "0.00" }}</b>
              </p>
              <p>
                Total Paid :
                <b>{{ total_Paid | currency : "&#8358;" || "0.00" }} </b>
              </p>
              <p>
                Total Balance :
                <b>{{ amount_owing | currency : "&#8358;" || "0.00" }} </b>
              </p>
            </div>
            <div>
              <button
                *ngIf="!buildLoad && amountRemaining !== 0"
                style="width: 200px"
                type="submit"
                [disabled]="stateForm.invalid"
                class="bill"
                mat-raised-button
                color="primary"
              >
                Save And Go To Bill Ledger
              </button>
              <button
                *ngIf="buildLoad"
                style="width: 200px"
                [disabled]="stateForm.invalid"
                type="submit"
                class="bill"
                mat-raised-button
                color="primary"
              >
                <i class="fa fa-spinner fa-spin" aria-hidden="true"></i></button
              ><br />
            </div>
            <br />
          </div>
        </form>
        <div class="search" *ngIf="visible" [@slideInOut]>
          <span class="form" style="margin-left: 30px">
            <mat-form-field class="size">
              <mat-label>Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="dob"
                (dateChange)="startDateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dob"
              ></mat-datepicker-toggle>
              <mat-datepicker #dob></mat-datepicker>
            </mat-form-field>
          </span>
          <span class="form" style="margin-left: 30px">
            <mat-form-field class="size">
              <mat-label>End Date</mat-label>
              <input
                matInput
                [matDatepicker]="end"
                (dateChange)="endDateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="end"
              ></mat-datepicker-toggle>
              <mat-datepicker #end></mat-datepicker>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Name</mat-label>
              <input [(ngModel)]="patientNmae" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Mobile No.</mat-label>
              <input
                type="number"
                [(ngModel)]="phone"
                matInput
                placeholder=""
              />
            </mat-form-field>
          </span>
          <div>
            <button
              (click)="searchEcounters()"
              style="margin-bottom: 30px; margin-left: 30px"
              mat-raised-button
              color="primary"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="single">
        <div>
          <p>
            Total Billed :
            <b>{{ acountStat[0]?.value | currency : "&#8358;" }} </b>
          </p>
          <p>
            Total Paid :
            <b>{{ acountStat[1]?.value | currency : "&#8358;" }} </b>
          </p>
        </div>
      </div>

      <div class="bottom">
        <div class="item">
          <table style="width: 100%" *ngIf="!isLoading">
            <tr class="back">
              <th>Patient Name</th>
              <th>Bill date</th>
              <th>Reg No.</th>
              <th>Total Amount</th>
              <th>Refund Amount</th>
              <th>Paid</th>
            </tr>
            <tr
              class="td"
              [ngClass]="{ active: item.selected }"
              *ngFor="let item of encounters"
              style="cursor: pointer"
              (click)="setItem(item)"
            >
              <td>{{ item.patientName }}</td>
              <td>{{ item.billDate | date }}</td>
              <td>{{ item.registration_no }}</td>
              <td>{{ item.totalAmount | currency : "&#8358;" }}</td>
              <td>{{ item.refundAmount | currency : "&#8358;" }}</td>
              <td>{{ item.Recd_Payment }}</td>
              <!-- <td *ngIf="!item.Recd_Payt">No</td> -->
            </tr>
          </table>
          <div *ngIf="isLoading" style="margin-top: 40px" class="spinner">
            <mat-spinner></mat-spinner>
          </div>
        </div>
      </div>
    </div>
  </app-template>
</div>
